module.exports = __webpack_public_path__ + "static/media/ic-account.19c11bf4.svg";